import { createAsyncThunk } from '@reduxjs/toolkit';

import { AuthService } from 'app/service/auth/auth-service';

export const logout = createAsyncThunk('auth/logout', async () => AuthService.logout());
